<template>
  <div>
    <div v-show="currentPage === 1">
      <div class="education-calculator">
        <div class="row">
          <div class="col-lg-12">
            <div class="card education-border">
              <div class="card-body">
                <v-form @submit.prevent="submitForm">
                  <div class="d-flex justify-content-between">
                    <div>
                      <h2>Input</h2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="education-input">
                        <label for="education-cost" class="label-spacing"
                          >Full cost of education in today's value</label
                        >
                        <span id="change-border" class="education-group">
                          <div class="rupees-symbol">₹</div>
                          <input
                            type="text"
                            class="form-control"
                            v-model="formData.cost"
                            outlined
                            id="education-cost"
                          />
                        </span>
                        <p class="validate-msg">{{ costMsg }}</p>
                      </div>
                      <div class="education-input">
                        <label for="current-investments" class="label-spacing"
                          >Value of current investments</label
                        >
                        <span id="change-border1" class="education-group">
                          <div class="rupees-symbol">₹</div>
                          <input
                            class="form-control"
                            type="text"
                            v-model="formData.current"
                            outlined
                            id="current-investments"
                          />
                        </span>
                        <p class="validate-msg">{{ currentMsg }}</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="education-input">
                        <label for="time-inflation" class="label-spacing"
                          >Expected inflation</label
                        >
                        <span class="education-group">
                          <button type="button" @click="decreaseReturns">
                            -
                          </button>
                          <input
                            class="form-control text-center"
                            type="text"
                            v-model="formData.inflation"
                            outlined
                            id="time-inflation"
                          />
                          <button type="button" @click="increaseReturns">
                            +
                          </button>
                        </span>
                      </div>
                      <div class="education-input">
                        <label for="time-period" class="label-spacing"
                          >Number of years remaining
                        </label>
                        <span class="education-group">
                          <button type="button" @click="decreaseTimePeriod">
                            -
                          </button>
                          <input
                            type="text"
                            v-model="formData.time"
                            class="form-control text-center"
                            outlined
                            id="time-period"
                          />
                          <button type="button" @click="increaseTimePeriod">
                            +
                          </button>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="education-input">
                        <label for="time-returns" class="label-spacing"
                          >Expected returns from investments</label
                        >
                        <span class="education-group">
                          <button
                            type="button"
                            @click="decreaseExpectedReturns"
                          >
                            -
                          </button>
                          <input
                            class="form-control text-center"
                            type="text"
                            v-model="formData.returns"
                            outlined
                            id="time-returns"
                          />
                          <button
                            type="button"
                            @click="increaseExpectedReturns"
                          >
                            +
                          </button>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6 mb-0" style="align-content: end">
                      <button
                        type="button"
                        @click="submitForm()"
                        class="btn"
                        style="
                          width: 100%;
                          background: #00a3d9;
                          color: white;
                          padding: 0.7em;
                          margin: 0px 0 12px;
                        "
                      >
                        Calculate
                      </button>
                    </div>
                    <div></div>
                  </div>
                </v-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="currentPage === 2">
      <div class="education-calculator">
        <div class="row">
          <div class="col-lg-12">
            <div class="card education-border">
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <div>
                    <h2>Output</h2>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="education-input">
                      <label for="future-cost" class="label-spacing"
                        >Estimated future cost of education</label
                      >
                      <span class="education-group education-color">
                        <input
                          type="text"
                          v-model="estimatedFutureCost"
                          outlined
                          :disabled="true"
                          class="form-control"
                          id="future-cost"
                        />
                      </span>
                    </div>
                    <div class="education-input">
                      <label for="plan-amount">Amount to plan for</label>
                      <span class="education-group education-color">
                        <input
                          type="text"
                          v-model="formattedAmount"
                          outlined
                          :disabled="true"
                          class="form-control"
                          id="plan-amount"
                        />
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="education-input">
                      <label for="future-value" class="label-spacing"
                        >Future value of current investments</label
                      >
                      <span class="education-group education-color">
                        <input
                          type="text"
                          v-model="futureCurrentInvestment"
                          outlined
                          :disabled="true"
                          class="form-control"
                          id="future-value"
                        />
                      </span>
                    </div>
                    <div class="education-input">
                      <label for="monthly-investment"
                        >Monthly investment needed</label
                      >
                      <span
                        class="education-group"
                        style="background: #21d19f99"
                      >
                        <input
                          type="text"
                          v-model="monthlyInvest"
                          outlined
                          :disabled="true"
                          class="form-control"
                          id="monthly-investment"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6"></div>
                  <div class="col-md-6">
                    <button
                      type="button"
                      @click="goToPage(1)"
                      class="education-button"
                    >
                      Start Over
                    </button>
                  </div>
                </div>
              </div>
              <i class="education-disclaim"
                >Disclaimer: Results shown for illustrative purpose only and
                should not be construed as investment advice</i
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EducationalCalculator",
  components: {},
  data() {
    return {
      formData: {
        cost: "",
        time: "1 Years",
        inflation: "3.5 %",
        current: "",
        returns: "12 %",
        minValue: 0,
        maxValue: 100,
      },
      monthlyInvestment: "",
      distributionValue: 75,
      maxValue: 100,
      estimatedFutureCost: " ₹ 0",
      futureCurrentInvestment: "₹ 0",
      formattedAmount: "₹ 0",
      monthlyInvest: "₹ 0",
      currentPage: 1,
      formSubmitted: false,
      costMsg: "",
      currentMsg: "",
    };
  },
  watch: {
    "formData.cost": function (newCost) {
      if (newCost) {
        document.getElementById("change-border").style.borderColor = "";
        this.costMsg = "";
      }
    },
    "formData.current": function (newCost) {
      if (newCost) {
        document.getElementById("change-border1").style.borderColor = "";
        this.currentMsg = "";
      }
    },
  },
  methods: {
    submitForm() {
      this.formSubmitted = true;
      if (!this.formData.cost) {
        document.getElementById("change-border").style.borderColor = "red";
        this.costMsg = "This field is required";
      }
      if (!this.formData.current) {
        document.getElementById("change-border1").style.borderColor = "red";
        this.currentMsg = "This field is required";
        return;
      }
      this.currentPage++;
      this.calculateTotalValue();
    },
    goToPage(pageNumber) {
      this.currentPage = pageNumber;
    },
    increaseReturns() {
      const numericValue = parseFloat(this.formData.inflation);
      if (numericValue > 3) {
        this.formData.inflation = `${Math.min(numericValue + 0.5, 20)} %`;
      }
    },
    decreaseReturns() {
      const numericValue = parseFloat(this.formData.inflation);
      if (numericValue <= 20.5) {
        this.formData.inflation = `${Math.max(numericValue - 0.5, 3)} %`;
      }
    },
    increaseExpectedReturns() {
      const numericValue = parseFloat(this.formData.returns);
      if (numericValue > 3.5) {
        this.formData.returns = `${Math.min(numericValue + 0.5, 50)} %`;
      }
    },
    decreaseExpectedReturns() {
      const numericValue = parseFloat(this.formData.returns);
      if (numericValue <= 50.5) {
        this.formData.returns = `${Math.max(numericValue - 0.5, 3)} %`;
      }
    },
    calculateTotalValue() {
      const futureCost = Math.round(
        this.formData.cost *
          Math.pow(
            1 + parseFloat(this.formData.inflation) / 100,
            parseFloat(this.formData.time)
          )
      );
      this.estimatedFutureCost = `₹ ${futureCost.toLocaleString("en-IN")}`;
      const annualReturns = parseFloat(this.formData.returns) / 100;
      const futureValue = Math.round(
        this.formData.current *
          Math.pow(1 + annualReturns, parseFloat(this.formData.time))
      );
      this.futureCurrentInvestment = `₹ ${futureValue.toLocaleString("en-IN")}`;
      const formattedAmount = Math.round(futureCost - futureValue);
      this.formattedAmount = `₹ ${formattedAmount.toLocaleString("en-IN")}`;
      const monthlyInvestmentNeeded = Intl.NumberFormat("en-IN").format(
        Math.round(
          (formattedAmount * (parseFloat(this.formData.returns) / (100 * 12))) /
            (Math.pow(
              1 + parseFloat(this.formData.returns) / (100 * 12),
              12 * parseFloat(this.formData.time)
            ) -
              1)
        )
      );
      this.monthlyInvest = `₹ ${monthlyInvestmentNeeded}`;
    },
    increaseTimePeriod() {
      const numericValue = parseInt(this.formData.time);
      if (numericValue < 50) {
        this.formData.time = `${numericValue + 1} Years`;
      }
    },
    decreaseTimePeriod() {
      const numericValue = parseInt(this.formData.time);
      if (numericValue > 1) {
        this.formData.time = `${numericValue - 1} Years`;
      }
    },
  },
};
</script>

<style scoped>
.change-color {
  border-color: red;
}

.validate-msg {
  color: #dd2e44;
  position: absolute;
  bottom: -15px;
  right: 5px;
  font-size: 12px;
}

.step-indicator-container {
  margin-top: 10px;
}

.step-button {
  padding: 10px 20px;
  border-radius: 5px;
  background-color: #f2f2f2;
  color: #012e40 !important;
}
.education-calculator .education-input label {
  display: block;
  font-weight: bold;
  font-size: 16px;
  color: #012e40 !important;
}

.education-color {
  background-color: #f2f2f2;
}
.education-input input {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}

.education-input {
  position: relative;
}

.education-group {
  display: flex;
  border: 1px solid #e5e5e5;
  margin: 0 0 10px;
  border-radius: 8px;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
}

.education-calculator .education-input button {
  background: transparent;
  border: none;
  color: #000000;
}

.education-button {
  width: 100%;
  background: #00a3d9;
  color: white;
  height: 40px;
  border-radius: 5px;
}
.label-spacing {
  margin-bottom: 0.7rem;
}

.education-border {
  border: none;
  outline: none;
  background: none;
}

.education-card input {
  border: none;
  outline: none;
  background: none;
  flex: 1;
  text-align: right;
}

.education-calculator {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  padding: 1%;
}

.rupees-symbol {
  display: flex;
  font-size: 14px;
  color: #555;
  margin: 10px;
}

.education-disclaim {
  color: #918d99;
  font-size: 14px;
  padding: 9px;
}
</style>
